<section class="left-nav-wrapper scroll-container">
  <div class="d-flex">
    <h1 class="page-title me-auto">Client Notes</h1>
    <div class="title-bar-btn">
      <button
        cpGTagEvent
        [params]="{ event_label: 'client_notes_view_history' }"
        class="btn btn-secondary"
        (click)="getClientNoteHistory(noteHistoryModal)">
        View History
      </button>
    </div>
    <div class="title-bar-btn">
      <button
        cpGTagEvent
        [params]="{ event_label: 'client_notes_archive' }"
        class="btn btn-secondary"
        (click)="archiveNote()"
        [disabled]="!clientNote || !clientNote.Note">
        Archive
      </button>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-lg-5 col-md-8">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <label>Notes</label>
            <small>
              <a (click)="getActiveClientNote()" class="cp-green">
                Refresh Note&nbsp;<i class="fas fa-sync-alt"></i>
              </a>
            </small>
          </div>
          <textarea
            class="form-control pre"
            [(ngModel)]="note"
            (ngModelChange)="saveNote()"
            rows="10"></textarea>
          <small *ngIf="clientNote && clientNote.LastModifiedBy">
            <strong>Last edited by</strong> {{ clientNote.LastModifiedBy }} <strong>on</strong>
            {{ clientNote.LastModifiedOn | date: 'MM/dd/yyyy h:mma' }}
          </small>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-4">
      <div class="card">
        <div class="card-body">
          <label>Expires On</label>
          <div class="input-group">
            <input
              class="form-control datepicker"
              [(ngModel)]="expireOnDate"
              ngbDatepicker
              #expireOnDatePicker="ngbDatepicker"
              (ngModelChange)="saveNote()"
              [placement]="['bottom-end', 'top-end']" />
            <img
              src="assets/icons/calendar.svg"
              (click)="expireOnDatePicker.toggle()"
              class="icon-append" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #noteHistoryModal let-modal>
  <div class="noteHistoryModal">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Note History</h4>
      <button
        cpGTagEvent
        [params]="{ event_label: 'client_notes_note_history_modal_dismiss' }"
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-12">
          <div *ngIf="!clientNoteHistory || clientNoteHistory.length <= 0">
            <em>No client note history to display</em>
          </div>
          <div *ngIf="clientNoteHistory && clientNoteHistory.length > 0">
            <table class="table table-border">
              <thead>
                <tr>
                  <th>Note</th>
                  <th>Last Modified By</th>
                  <th>Expiration Date</th>
                  <th>Archived On</th>
                  <th>Archived By</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let note of clientNoteHistory">
                  <td>{{ note.Note }}</td>
                  <td>{{ note.LastModifiedBy }}</td>
                  <td>{{ note.ExpiresOn | date: 'MM/dd/yyyy' }}</td>
                  <td>{{ note.ArchivedOn | date: 'MM/dd/yyyy' }}</td>
                  <td>{{ note.ArchivedBy }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        cpGTagEvent
        [params]="{ event_label: 'client_notes_note_history_modal_cancel' }"
        type="button"
        class="btn btn-secondary"
        (click)="modal.dismiss()">
        Cancel
      </button>
    </div>
  </div>
</ng-template>
